import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@redux/reducers/rootReducer';

const usersState = (state: RootState) => state.common.users;

const getUsersState = createSelector(usersState, (state) => state);

const getUsersLoading = createSelector(usersState, (state) => state.usersLoading);

export const usersSelectors = {
  getUsersState,
  getUsersLoading,
};
